<div class="mt-4 mb-4">
  <form *ngIf="renderForm" [formGroup]="otpEntryForm" (ngSubmit)="emitValidOtp($event)">
    <div id="otp-field-container">
      <ng-otp-input #otpInputField id="otp-input-field" formControlName="otp" 
          (onInputChange)="emitValidOtp($event)" [config]="OTP_INPUT_CONFIG">
      </ng-otp-input>
    </div>
    <div *ngIf="otpEntryForm.controls['otp'].invalid && otpEntryForm.controls['otp'].dirty" class="alert alert-danger move-up mb-0 mt-2">
      <div *ngIf="otpEntryForm.controls['otp'].errors?.required" class="alert-red">
          One Time Code is required.
      </div>
      <div *ngIf="otpEntryForm.controls['otp'].errors?.pattern" class="alert-red">
          Invalid character. Only numbers are accepted as input.
      </div>
    </div>
    <!-- Dummy submit button, for simple automation option and enter keypress-->
    <button type="submit" class="hidden"></button>
  </form>
</div>